var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F5FAF7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1478_8948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1478_8948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 16H16V40H40V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1478_8948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0851 28.6817C37.1778 31.9453 32.8961 34.5966 28.0001 34.5966C23.1041 34.5966 18.8223 31.9453 16.9151 28.6817C16.695 28.3056 16.695 27.6943 16.9151 27.3182C18.8223 24.0546 23.1041 21.4033 28.0001 21.4033C32.8961 21.4033 37.1778 24.0546 39.0851 27.3182C39.3052 27.6943 39.3052 28.3056 39.0851 28.6817ZM23.2027 27.9999C23.2027 25.3524 25.3526 23.2026 28.0001 23.2026C30.6476 23.2026 32.7975 25.3524 32.7975 27.9999C32.7975 30.6474 30.6476 32.7973 28.0001 32.7973C25.3526 32.7973 23.2027 30.6474 23.2027 27.9999Z",
    fill: "#008B39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1387 28C24.1387 25.8681 25.8693 24.1375 28.0012 24.1375C30.133 24.1375 31.8637 25.8681 31.8637 28C31.8637 30.1318 30.133 31.8625 28.0012 31.8625C25.8693 31.8625 24.1387 30.1318 24.1387 28Z",
    fill: "#008B39"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1478_8948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.8d89f2e692538e75d4834c56c9a31b80.svg";
export { ForwardRef as ReactComponent };